export default {
  OK: "好",
  ok: "好",
  loginFailed: "登錄失敗，請重試。",
  requestFailed: "請求失敗，請檢查您的互聯網連接。",
  invalidLogin: "使用者名或密碼無效。",
  thisFunctionExists: "這個函數已經存在了。",
  thisFunctionNotAllowDelete: "不允許刪除此功能。",
  thisFunctionNotExists: "這個函數不存在。",
  targetFunctionIdRequired: "需要目標函數 ID。",
  thisPageExists: "此頁面已經存在。",
  thisPageNotAllowDelete: "此頁面不允許刪除。",
  thisRoleExists: "這個角色已經存在了。",
  thisRoleNotAllowDelete: "不允許刪除此角色。",
  targetRoleIdRequired: "需要目標角色 ID。",
  invalidParameter: "參數無效。",
  systemError: "系統無法處理您的請求。",
  spErrorMessage: "SP 消息錯誤（取決於什麼錯誤）。",
  actionbyRequired: "當前使用者是必需的。",
  sessionTokenRequired: "需要會話令牌。",
  functionIdRequired: "需要函數 ID。",
  functionNameRequired: "函數名稱是必填的。",
  newFunctionNameRequired: "函數名稱是必填的。",
  pageIdRequired: "需要頁面 ID。",
  newPageIdRequired: "需要頁面 ID。",
  newPageNameRequired: "頁面名稱是必填項。",
  targetPageIdRequired: "需要目標頁面 ID。",
  passwordRequired: "需要密碼。",
  userNameRequired: "全名是必填的。",
  passwordValidation: "密碼必須是 6-20 個字元，並且是數位和字母的組合。",
  pageNumRequired: "頁碼是必填的。",
  pageSizeRequired: "頁面大小是必需的。",
  roleIdRequired: "需要角色ID",
  oldPasswordRequired: "需要當前密碼。",
  userStatusRequired: "用戶狀態是必需的。",
  newRoleIdRequired: "角色 ID 是必填的。",
  newRoleNameRequired: "角色名稱是必填的。",
  startDateIsGteEndDate: "開始日期大於結束日期。",
  thisRoleNotExists: "這個角色不存在。",
  thisPageNotExists: "此頁面不存在。",
  thisUserExists: "此使用者已存在。",
  thisUserNotExists: "此使用者不存在。",
  thisUserBlackListed: "您的帳戶已被暫停。",
  thisUserInactive: "您的帳戶已被禁用。",
  thisUserBlocked: "您的帳戶已被凍結。",
  thisUserNotActive: "您的帳戶已被禁用。",
  InvalidPageFunction: "頁面功能無效。",
  invalidUser: "無效使用者！",
  invalidToken: "會話無效！",
  NoUserAccessRight: "許可被拒絕！",
  connection: "連接錯誤",
  profileIdRequired: "需要個人資料 ID。",
  packageIdRequired: "需要包 ID。",
  fullNameMinThreeChar: "全名必須至少包含 3 個字元。",
  accountIdMinThreeChar: "帳戶 ID 必須至少包含 3 個字元。",
  searchCriteriaRequired: "搜索條件是必需的。",
  affiliateIdRequired: "需要代理ID。",
  minDepositRequired: "需要最低存款。",
  bonusRateRequired: "獎金率是必需的。",
  onlyAllowRejectDeposit: "只允許拒絕押金票。",
  senderBankIdRequired: "需要發件人銀行 ID。",
  senderBankAccNoRequired: "寄件者銀行賬戶編號。是必需的。",
  minFTDAmtNumOnly: "最小 FTD Amt 僅接受數位。",
  maxFTDAmtNumOnly: "最大FTD Amt 僅接受數位。",
  crmBasicCriteriaRequired: "需要提供會員 ID / 聯繫電話 / 聯繫電子郵件 / 註冊日期 / 最後登錄日期。",
  verifiedDateRangeAllowThreeMonths: "註冊日期範圍最多只允許選擇 3 個月。",
  lastLoginDateRangeAllowThreeMonths: "上次登錄日期範圍最多只允許選擇 3 個月。",
  depositDateRangeAllowThreeMonths: "存款日期範圍只允許選擇最多 3 個月。",
  ftdDateRangeAllowThreeMonths: "FTD 日期範圍最多只允許選擇 3 個月。",
  ltdDateRangeAllowThreeMonths: "LTD 日期範圍最多只允許選擇 3 個月。",
  lastLoginDateEarlierThanVerifiedDate: "最後登錄日期早於註冊日期。",
  depositDateEarlierThanVerifiedDate: "存款日期早於註冊日期。",
  ftdDateEarlierThanVerifiedDate: "FTD 日期早於註冊日期。",
  ltdDateEarlierThanVerifiedDate: "LTD 日期早於註冊日期。",
  ftdFromRequired: "需要從日期開始的 FTD。",
  ftdToRequired: "迄今為止需要 FTD。",
  ltdFromRequired: "需要從日期起的 LTD。",
  ltdToRequired: "迄今為止需要 LTD。",
  failedToLaunchPaymentGateway: "無法啟動支付閘道。",
  enTitleRequired: "需要 EN 標題。",
  enBodyRequired: "需要 EN Body。",
  enImageUrlRequired: "需要 EN 圖像 URL。",
  enImageUrlDesktopRequired: "需要 EN 桌面圖像 URL。",
  enAltRequired: "需要 EN Alt。",
  enHrefRequired: "需要 EN Href。",
  resubmitTicketRequired: "需要重新提交工單。",
  withtholdBonusAndAmountGreaterThanZero: "扣留贈金和扣留金額不能同時大於零。",
  maxWithdrawMultipleAndAmountGreaterThanZero: "最大提款倍數和最大提款金額不能同時大於零。",
  serverBusy: "「伺服器現在很忙」。請重試。",
  isRequired: "請輸入{fname}。",
  isMinValue: "{fname} 必須具有最小值 {fvalue}。",
  isMaxValue: "{fname} 必須小於或等於 {fvalue}。",
  isMinLength: "{fname} 必須至少有 {fvalue} 個字符。",
  isMaxLength: "{fname} 必須小於或等於 {fvalue} 個字元。",
  isAlpha: "{fname} 只接受字母表。",
  isAlphaNum: "{fname} 僅接受字母數位。",
  isNumeric: "{fname} 只接受數位。",
  isEmail: "{fname} 僅接受有效的電子郵件位址。",
  isIpAddress: "{fname} 僅接受有效的 IPv4 位址。",
  isSameAs: "{fname} 必須與 {fname2} 相同。",
  isUrl: "{fname} 只接受 URL。",
  containAlphaNum: "{fname} 必須至少有一個字母表和一個數位。",
  alphaNumWithSpace: "{fname} 僅接受字母數位。",
  isDecimal: "{fname} 只接受數位。",
  isInteger: "{fname} 只接受整數。",
  selectOption: "請選擇一個 {fname}",
  notSameAs: "{fname} 和 {fname2} 不能相同。",
  dateRangeAllowOneMonth: "日期範圍最多只允許選擇 1 個月。",
  dateRangeAllowOneYear: "日期範圍最多只允許選擇 1 年。",
  greaterThanZero: "{fname} 必須大於零。",
  atLeastOneAuthority: "必須至少選擇一個權威機構。",
  BLOCK: "您的帳戶已被凍結。",
  SUSPEND: "您的帳戶已被暫停。",
  CLOSE: "您的帳戶已被關閉。",
  RESETL: "您的帳戶已被重置。",
  atLeastOneProvider: "必須至少選擇一個供應商。",
  failedToGetResultUrl: "無法獲取結果 url。",
  fileSizeValidation: "太大，允許的最大大小為 1mb",
  atLeastOnePaymentOption: "必須選擇至少一個付款方式。",
  atLeastOnePaymentGateway: "必須至少選擇一個支付網關。",
  dateRangeAllow31Days: "日期範圍最多只允許選擇 31 天。",
  dateRangeAllow31Months: "日期範圍只允許選擇最多 31 個月。",
  dateRangeAllow31Years: "日期範圍只允許選擇最多 31 年。",
  invalidCategory: "無效類別。",
  noChanges: "沒有變化。",
  permissionDenied: "許可被拒絕。",
  referralCodeRequired: "需要推薦代碼。",
  providerDescRequired: "需要提供程式描述。",
  marqueeContentRequired: "選框內容是必需的。",
  bonusNameRequired: "獎金名稱是必填的。",
  baseAmountRequired: "需要基本金額。",
  reviewIdRequired: "需要審閱ID。",
  surveyIdRequired: "需要調查ID。",
  questionRequired: "需要提問。",
  iframeIdRequired: "需要 Iframe ID。",
  bonusAmountRequired: "獎金金額是必需的。",
  inboxIdRequired: "收件箱 ID 是必填項。",
  exchangedAmountRequired: "需要兌換金額。",
  baseRateRequired: "需要基本費率。",
  exchangeRateRequired: "需要匯率。",
  baseCurrencyRequired: "基礎貨幣是必填的。",
  exchangeCurrencyRequired: "需要兌換貨幣。",
  depositTypeRequired: "需要存款類型。",
  nbRedepositRequired: "需要重新存入 Nb。",
  bankOwnerRequired: "需要銀行擁有者。",
  autoSenderRequired: "需要自動發送者。",
  isRecommendRequired: "是推薦是必需的。",
  recipientBankIdRequired: "需要收款銀行 ID。",
  recipientBankAccNoRequired: "收款人銀行帳號是必填的。",
  accountBalanceRequired: "需要賬戶餘額。",
  incomingAmountThresholdRequired: "需要傳入金額閾值。",
  incomingFrequencyThresholdRequired: "需要傳入頻率閾值。",
  outgoingAmountThresholdRequired: "需要支付金額閾值。",
  outgoingFrequencyThresholdRequired: "需要傳出頻率閾值。",
  bankAccTypeRequired: "銀行帳戶類型是必填項。",
  packageRequired: "需要包。",
  rtpRequired: "需要 RTP。",
  domainIdRequired: "需要功能變數名稱ID。",
  buyOnBehalfRequired: "需要代購。",
  serviceProviderRequired: "需要服務提供者。",
  serverAccountRequired: "需要伺服器帳戶。",
  nameServerRequired: "需要名稱伺服器。",
  socialLinkRequired: "需要社交連結。",
  newSocialPlatformRequired: "需要新的社交平臺。",
  attachmentPathRequired: "需要附件路徑。",
  depositMethodRequired: "需要存款方式。",
  depositDateRequired: "需要存款日期。",
  refNoRequired: "參考編號是必填的。",
  withdrawalAmountRequired: "需要提款金額。",
  targetBankAccNoRequired: "需要目標銀行帳號。",
  targetBankIdRequired: "需要目標銀行 ID。",
  jsonRatingRequired: "需要 JSON 評級。",
  startTimeRequired: "需要開始時間。",
  accountIdRequired: "需要帳戶 ID。",
  parentIdRequired: "需要家長 ID。",
  amountRequired: "金額是必需的。",
  clientIpRequired: "用戶端 IP 是必需的。",
  auditByRequired: "需要審計。",
  systemTypeRequired: "系統類型是必需的。",
  currencyRequired: "貨幣是必需的。",
  ipAddressRequired: "需要IP 位址。",
  affiliateCodeRequired: "需要代理代碼。",
  contactPhoneRequired: "需要聯繫電話。",
  requestTypeRequired: "請求類型是必需的。",
  securityDisabledRequired: "需要禁用安全。",
  gameCodeRequired: "需要遊戲代碼。",
  seqRequired: "需要順序。",
  minLimitRequired: "需要最低限額。",
  maxLimitRequired: "需要最大限制。",
  commSportsRequired: "需要體育委員會。",
  commSlotsRequired: "需要老虎機傭金。",
  commLivecasinoRequired: "真人娛樂場需要傭金。",
  commCockfightRequired: "需要鬥雞的傭金。",
  commOthersRequired: "需要為他人委託。",
  settingValueRequired: "設置值是必填的。",
  vipIdRequired: "需要 VIP ID。",
  carryOverRequired: "需要結轉。",
  campaignIdRequired: "需要推廣活動 ID。",
  titleRequired: "頭銜是必填的。",
  bodyRequired: "身體是必需的。",
  itemOrderRequired: "需要專案順序。",
  imageUrlRequired: "圖片 URL 是必需的。",
  bannerIdRequired: "需要橫幅 ID。",
  directionRequired: "需要指導。",
  defaultOrderRequired: "默認訂單是必需的。",
  altRequired: "需要替代文本。",
  hrefRequired: "需要 Href。",
  targetWindowRequired: "目標視窗是必需的。",
  loginRequiredRequired: "需要登錄。",
  activeFromRequired: "需要主動寄件者。",
  activeToRequired: "需要主動到。",
  bannerTypeRequired: "需要橫幅類型。",
  pageNameRequired: "頁面名稱是必填項。",
  remarkRequired: "需要備註。",
  settingKeyRequired: "需要設置鍵。",
  memberListRequired: "成員名單是必填的。",
  memberIdRequired: "會員 ID 是必填的。",
  workingMonthRequired: "需要工作月。",
  workingDateRequired: "工作日期是必填的。",
  tacRequired: "需要條款和條件。",
  paymentModeRequired: "需要付款方式。",
  newPasswordRequired: "需要新密碼。",
  loginIdRequired: "需要登錄ID。",
  securityTagRequired: "需要安全標籤。",
  securityCodeRequired: "需要安全碼。",
  providerCodeRequired: "提供程式代碼是必需的。",
  startDateRequired: "開始日期是必填項。",
  endDateRequired: "結束日期是必填項。",
  searchIdRequired: "需要搜索ID。",
  authTokenRequired: "需要身份驗證令牌。",
  newStatusRequired: "需要新狀態。",
  actionRequired: "需要採取行動。",
  promotionIdRequired: "需要促銷ID。",
  promotionNameRequired: "促銷名稱是必填項。",
  rolloverRequired: "需要翻轉。",
  criteriaRequired: "標準是必需的。",
  ticketIdRequired: "需要門票 ID。",
  resultIdRequired: "需要結果 ID。",
  bankIdRequired: "需要銀行 ID。",
  bankAccNoRequired: "銀行帳號是必填的。",
  bankAccHolderRequired: "需要銀行帳戶持有人。",
  newBankIdRequired: "需要新的銀行ID。",
  newBankAccNoRequired: "需要新的銀行帳號。",
  newBankAccHolderRequired: "需要新的銀行帳戶持有人。",
  fullNameRequired: "全名是必填的。",
  depositAmountRequired: "需要押金金額。",
  gatewayAccRequired: "需要網關帳戶。",
  labelNameRequired: "標籤名稱是必填的。",
  labelIdRequired: "需要標籤 ID。",
  bankTypeRequired: "銀行類型是必填的。",
  amountLimitRequired: "需要金額限制。",
  currencyRateRequired: "貨幣匯率是必需的。",
  urlRequired: "URL 是必需的。",
  cashRequired: "需要現金。",
  csRequired: "需要客戶支援。",
  vipNameRequired: "VIP 名稱是必填的。",
  campaignNameRequired: "活動名稱是必填項。",
  transferIdRequired: "需要傳輸ID。",
  betTimeRequired: "需要下注時間。",
  turnoverRequired: "需要營業額。",
  payoutRequired: "需要支付。",
  winloseRequired: "贏/輸是必需的。",
  rawMessageRequired: "需要原始消息。",
  authStatusRequired: "需要身份驗證狀態。",
  dateRequired: "日期是必填的。",
  betIdRequired: "需要投注 ID。",
  betStatusRequired: "需要投注狀態。",
  betAmountRequired: "需要下注金額。",
  isParlayRequired: "需要連贏嗎。",
  isAddonRequired: "是需要外掛程式的。",
  withholdBonusRequired: "需要預扣獎金。",
  withholdAmountRequired: "需要預扣金額。",
  maxWithdrawAmountRequired: "需要最大提款金額。",
  betTypeRequired: "投注類型是必填的。",
  maxWithdrawMultipleRequired: "需要最大提款倍數。",
  socialPlatformRequired: "社交平臺是必需的。",
  vipProviderRebateRequired: "需要 VIP 提供者回扣。",
  selfRebateRateRequired: "需要自我返利率。",
  downlineRebateRateRequired: "需要下線返利率。",
  tierIdRequired: "需要層級 ID。",
  rebateRateRequired: "需要回扣率。",
  paymentGatewayRequired: "需要支付閘道。",
  rescueIdRequired: "需要救援ID。",
  rescueNameRequired: "需要救援名稱。",
  rescueCycleRequired: "需要救援週期。",
  minLoseRequired: "要求最小損失。",
  rescueRateRequired: "需要搶救率。",
  maxPayoutRequired: "需要最高支出。",
  payoutMethodRequired: "需要支付方式。",
  targetGroupRequired: "目標群體是必需的。",
  maintainDepositRequired: "需要維持押金。",
  maintainTurnoverRequired: "需要保持營業額。",
  depositOrTurnoverRequired: "需要押金或營業額。",
  maintainDepositOrMaintainTurnoverRequired: "需要維持押金或維持營業額。",
  vipListRequired: "VIP名單是必填的。",
  gameNameRequired: "遊戲名稱是必填項。",
  claimTypeRequired: "聲明類型是必需的。",
  operatorIdRequired: "需要操作員 ID。",
  maxBonusRequired: "需要最高獎金。",
  endTimeRequired: "需要結束時間。",
  mondayRequired: "星期一是必需的。",
  tuesdayRequired: "星期二是必需的。",
  wednesdayRequired: "星期三是必需的。",
  thursdayRequired: "星期四是必需的。",
  fridayRequired: "星期五是必需的。",
  saturdayRequired: "星期六是必需的。",
  sundayRequired: "周日是必需的。",
  promotionTypeRequired: "促銷類型是必填項。",
  claimLimitRequired: "需要索賠限額。",
  bonusRate1Required: "獎金率為 1 是必需的。",
  bonusRate1To2Required: "獎金率為 1 至 2 是必需的。",
  bonusRate1To3Required: "獎金率為 1 至 3 是必需的。",
  bonusRate1To4Required: "獎金率為 1 至 4 是必需的。",
  bonusRate1To5Required: "獎金率為 1 至 5 是必需的。",
  bonusRate1To6Required: "獎金率為 1 至 6 是必需的。",
  bonusRate1To7Required: "獎金率為 1 至 7 是必需的。",
  externalIdRequired: "需要外部 ID。",
  opsiteRequired: "Opsite 是必需的。",
  opsiteContentRequired: "Opsite 內容是必需的。",
  opsiteLanguageRequired: "Opsite 語言是必需的。",
  opsitePaymentRequired: "需要Opsite付款。",
  opsiteProviderRequired: "需要 Opsite 提供者。",
  opsiteProviderGamesRequired: "Opsite provider 遊戲是必需的。",
  accountTypeRequired: "帳戶類型為必填項。",
  domainNameRequired: "域名是必填的。",
  settledTimeRequired: "需要確定的時間。",
  validTurnoverRequired: "需要有效營業額。",
  resultTimeRequired: "需要結果時間。",
  resultStatusRequired: "結果狀態是必填項。",
  secondIdRequired: "需要第二個身份證件。",
  domainListRequired: "域清單是必填的。",
  domainTypeRequired: "域類型是必填項。",
  moduleRequired: "模組是必需的。",
  gameIdRequired: "需要遊戲ID。",
  gameDetailRequired: "需要遊戲細節。",
  bonusRate1To8Required: "獎金率為 1 至 8 是必需的。",
  bonusRate1To9Required: "獎金率為 1 至 9 是必需的。",
  bonusRate1To10Required: "獎金率為 1 至 10 是必需的。",
  invalidOrder: "訂單無效。",
  bannerNotExists: "旗幟不存在。",
  invalidBannerType: "橫幅類型無效。",
  pageNameExists: "頁面名稱存在。",
  pageNotExists: "頁面不存在。",
  tacIsValid: "OTP 有效。",
  invalidTac: "OTP 無效。",
  tacExpired: "OTP 已過期。",
  tacNotValidate: "OTP 未驗證。",
  paymentModeNotExists: "支付方式不存在。",
  paymentOptionProviderNotExists: "付款選項供應商不存在。",
  ipAddressExists: "IP 位址存在。",
  ticketProcessed: "工單已處理。",
  bankAccountNotExists: "銀行帳戶不存在。",
  bankAccountInactive: "銀行帳戶不活躍。",
  bankMemberNotExists: "銀行成員不存在。",
  bankMemberInactive: "銀行成員不活躍。",
  affiliateExists: "代理存在。",
  contactPhoneExists: "聯繫電話存在。",
  affiliateFull: "代理已滿。",
  uplineInactive: "上線不活躍。",
  applicationProcessed: "申請已處理。",
  tacValidated: "條款和條件已驗證。",
  applicationPending: "申請待定。",
  favouriteGameExists: "最喜歡的遊戲存在。",
  invalidLimit: "無效限制。",
  settingNotSet: "設置未設置。",
  domainNameNotExists: "域名不存在。",
  domainNameFull: "域名已滿。",
  domainNameNotAvailable: "域名不可用。",
  domainNameExists: "域名存在。",
  subAccountNotExists: "子帳戶不存在。",
  settingNotExists: "設置不存在。",
  invalidContactEmail: "聯繫電子郵件無效。",
  accountInactive: "帳戶處於非活動狀態。",
  campaignNotExists: "競選活動不存在。",
  paymentProviderNotExists: "支付提供者不存在。",
  profileInactive: "配置檔處於非活動狀態。",
  minWithdrawalNotMet: "未達到最低提款額。",
  invalidBankId: "銀行ID無效。",
  bankAccountExists: "銀行帳戶存在。",
  bankAccountFull: "銀行帳戶已滿。",
  bankAccHolderNotSame: "銀行帳戶持有人不一樣。",
  exceedMaxWithdrawal: "超過最大提款額。",
  exceedWithdrawalFrequency: "超過提款頻率。",
  invalidPackage: "包無效。",
  promotionNotAvailable: "促銷不可用。",
  ongoingPromotion: "正在進行推廣。",
  pendingResultInGame: "遊戲待定結果。",
  labelNameExists: "標籤名稱存在。",
  labelNotExists: "標籤不存在。",
  invalidFtdMin: "首次存款最低限額無效。",
  invalidFtdMax: "首次存款最高限額無效。",
  ftdMinGtFtdMax: "首次存款最低限額大於最高限額。",
  vipFull: "貴賓滿員。",
  invalidRewardType: "獎勵類型無效。",
  vipExists: "VIP 存在。",
  vipNotExists: "VIP 不存在。",
  onlyOneMaxWithdrawSetting: "只允許進行一次最大提款設置。",
  onlyOneWithholdSetting: "只允許進行一次預扣設置。",
  campaignExists: "活動存在。",
  vipProviderNotExists: "VIP 提供者不存在。",
  turnoverTierExists: "營業額層存在。",
  turnoverTierFull: "營業額等級超過最高等級。",
  turnoverTierNotExists: "營業額層不存在。",
  invalidSettingValue: "設置值無效。",
  turnoverTierNotSet: "營業額等級未設置。",
  rebateProcessed: "返利已處理。",
  invalidActionType: "作類型無效。",
  invalidRescueCycle: "無效的救援週期。",
  invalidPayoutMethod: "無效的提現方式。",
  invalidTargetGroup: "目標群體無效。",
  rescueExists: "救援存在。",
  rescueNotExists: "救援不存在。",
  walletExists: "錢包存在。",
  accountExists: "帳戶存在。",
  activeFromGtActiveTo: "主動從大於主動到",
  accountNotExists: "運營商ID不存在。",
  invalidDeposit: "存款無效。",
  invalidTurnover: "營業額無效。",
  providerCodeNotExists: "提供程式代碼不存在。",
  gameNameExists: "遊戲名稱存在。",
  gameNameNotExists: "遊戲名稱不存在。",
  invalidAccountType: "帳戶類型無效。",
  invalidLoginIdFormat: "登錄 ID 格式無效。",
  invalidReferralCode: "推薦代碼無效。",
  firstDepositNotMet: "未滿足第一筆存款。",
  newbieNotMet: "未滿足新手要求。",
  claimPromoOnlyOnce: "僅領取一次促銷。",
  promotionRequirementNotMet: "未滿足晉陞要求。",
  withdrawalAmountLteWithholdAmount: "提款金額小於或等於預扣金額。",
  subAccountInactive: "子帳戶處於非活動狀態。",
  gameNotSupported: "不支援遊戲。",
  startTimeGteEndTime: "開始時間大於或等於結束時間。",
  invalidPromotionType: "促銷類型無效。",
  invalidClaimType: "聲明類型無效。",
  claimLimitExceeded10: "索賠限額超過 10 次。",
  verificationFailed: "驗證失敗。",
  claimLimitReached: "已達到索賠限額。",
  invalidPromotion: "無效的促銷。",
  socialPlatformExists: "社交平臺存在。",
  duplicateReview: "重複審閱。",
  invalidSurveyId: "調查ID無效。",
  accountNotBlock: "帳戶未被阻止。",
  walletNotExists: "錢包不存在。",
  socialPlatformNotExists: "社交平臺不存在。",
  socialPlatformInactive: "社交平臺不活躍。",
  accountSocialExists: "社交帳戶存在。",
  invalidStatus: "狀態無效。",
  samePassword: "相同的密碼。",
  invalidPassword: "使用者名或密碼無效。",
  secondaryAccountExists: "輔助帳戶存在。",
  invalidSecurityCode: "安全代碼無效。",
  accountSocialNotExists: "帳戶社交不存在。",
  providerInactive: "提供程式處於非活動狀態。",
  gameIdExists: "遊戲 ID 存在。",
  gameIdNotExists: "遊戲ID 不存在。",
  parentProviderInactive: "父提供者處於非活動狀態。",
  betLimitNotExists: "投注限額不存在。",
  min3Characters: "最少 3 個字元。",
  invalidBankAccType: "銀行帳戶類型無效。",
  senderBankNotExists: "發件人銀行不存在。",
  recipientBankNotExists: "收款銀行不存在。",
  affiliateNotExists: "代理不存在。",
  redepositedTicket: "重新存入的機票。",
  invalidDepositType: "存款類型無效。",
  affiliateInactive: "代理處於非活動狀態。",
  bonusUnavailable: "獎金不可用。",
  pendingDeposit: "待定金。",
  noOngoingPromotion: "沒有持續的晉陞。",
  iframeNotExists: "IFrame 不存在。",
  gameMaintenance: "遊戲維護。",
  labelInactive: "標籤非活動狀態。",
  invalidDomainType: "域類型無效。",
  invalidModule: "模塊無效。",
  labelFull: "標籤已滿。",
  questionExists: "問題存在。",
  questionFull: "問題滿了。",
  questionNotExists: "問題不存在。",
  reviewNotExists: "評論不存在。",
  invalidDomainGroup: "域組無效。",
  invalidDateRange: "日期範圍無效。",
  ipAddressNotExists: "IP 位址不存在。",
  marqueeNotExists: "Marquee 不存在。",
  invalidAmount: "金額無效。",
  insufficientBalance: "餘額不足。",
  minLimitLtParent: "最小限制小於父級。",
  maxLimitGtParent: "最大限制大於父級。",
  startDateGtEndDate: "開始日期大於結束日期。",
  currencyNotExists: "貨幣不存在。",
  currencyExists: "貨幣存在。",
  noAccumulateWin: "沒有累積的勝利。",
  invalidSession: "會話無效。",
  sessionExpired: "會話已過期。",
  promotionExists: "促銷存在。",
  invalidCriteria: "無效標準。",
  promotionNotExists: "促銷不存在。",
  ticketNotExists: "票不存在。",
  duplicateDebitRecord: "重複借記記錄。",
  duplicateCreditRecord: "重複的信用記錄。",
  debitRecordNotExists: "借方記錄不存在。",
  minDepositNotMet: "未達到最低存款額。",
  duplicateBet: "重複投注。",
  invalidProviderCode: "無效的供應商代碼。",
  resultExists: "結果存在。",
  unableSPProcess: "系統無法處理您的請求。",
  authRequired: "需要驗證碼。",
  domainExists: "域已存在。",
  multiSelectOption: "請選擇 {fname}",
  invalidDomainFormat: "域格式無效",
  noHttpHttps: "'https://'或'http://'是不允許的。",
  noReservedSubdomain: "不允許保留子域。對於應用程式下載連結的使用。",
  operatorInactive: "運算子處於非活動狀態",
  invalidAccountIdFormat: "帳戶 ID 格式無效",
  contentIdRequired: "需要功能表 ID",
  themeCodeRequired: "需要主題代碼",
  themeNameRequired: "主題名稱是必填的",
  themeColorRequired: "主題顏色是必填的",
  languageRequired: "語言是必需的",
  positionRequired: "職位是必需的",
  themeContentIdRequired: "需要主題內容 ID",
  emailRequired: "電子郵件是必填的",
  themeProviderTypeRequired: "主題提供程式類型是必需的",
  phoneRequired: "需要電話",
  targetTypeRequired: "目標類型是必需的",
  packageTypeRequired: "包類型是必需的",
  renewTermRequired: "需要續期",
  packagePriceRequired: "套餐價格是必需的",
  packageStatusRequired: "包狀態是必需的",
  sortKeyRequired: "需要排序鍵",
  invalidDomainStatus: "域名狀態無效",
  invalidCurrency: "無效貨幣",
  invalidThemeCode: "主題代碼無效，",
  invalidLanguage: "語言無效",
  invalidPosition: "無效倉位",
  invalidThemeContent: "無效的主題內容",
  allParamsSameAsCurrent: "沒有變化",
  invalidThemeColor: "主題顏色無效，",
  invalidCartStatus: "購物車狀態無效",
  invalidThemeProviderType: "主題提供程式類型無效",
  themeProviderTypeCannotBeUse: "「無法使用主題提供程式類型」，",
  invalidUserStatus: "「用戶狀態無效」，",
  packageCannotBeRemove: "「無法刪除包」，",
  userStatusIsAlrdSuspend: "「用戶已暫停」，",
  userStatusIsAlrdBlocked: "使用者已被阻止",
  userStatusIsAlrdActive: "「用戶已處於活動狀態」，",
  invalidSortType: "排序類型無效",
  startDateBiggerThanEndDate: "開始日期大於結束日期",
  positionCannotBeUse: "位置不能使用",
  funcAddContentFailed: "「無法添加內容」，",
  funcDeleteContentFailed: "「無法刪除內容」，",
  funcUpdateContentFailed: "無法更新內容",
  funcAddThemeFailed: "「無法添加主題」，",
  funcDeleteThemeFailed: "「無法刪除主題」，",
  funcUpdateThemeFailed: "無法更新主題",
  funcAddThemeColorFailed: "「無法添加主題顏色」，",
  funcDeleteThemeColorFailed: "「無法刪除主題顏色」，",
  funcUpdateThemeColorFailed: "「無法更新主題顏色」",
  funcAddLanguageFailed: "「無法添加語言」，",
  funcDeleteLanguageFailed: "「無法刪除語言」，",
  funcUpdateLanguageFailed: "無法更新語言",
  funcAddThemeContentFailed: "「無法添加主題內容」，",
  funcDeleteThemeContentFailed: "「無法刪除主題內容」，",
  funcUpdateThemeContentFailed: "「無法更新主題內容」，",
  funcAddContentPositionFailed: "「無法添加內容位置」，",
  funcUpdateContentPositionFailed: "「無法更新內容位置」，",
  funcDeleteContentPositionFailed: "「無法刪除內容位置」，",
  funcAddThemeProviderTypeFailed: "「無法添加主題提供程式類型」，",
  funcUpdateThemeProviderTypeFailed: "「無法更新主題提供程式類型」，",
  funcDeleteThemeProviderTypeFailed: "「無法刪除主題提供者類型」，",
  funcAddPackageFailed: "「無法添加包」，",
  funcUpdatePackageFailed: "無法更新包",
  funcDeletePackageFailed: "「無法刪除包」，",
  nicknameRequired: "昵稱是必填的",
  accountStatusRequired: "帳戶狀態是必填項",
  contentIdMaxLength50: "功能表ID最大長度為50",
  positionMaxLength10: "位置最大長度為 10",
  contentDescMaxLength200: "內容描述最大長度為 200",
  domainStatusRequired: "域狀態是必填項",
  funcAddDomainFailed: "「無法添加域」，",
  funcUpdateDomainFailed: "無法更新域",
  uploadFailed: "上傳失敗！",
  sortKeyMaxLength50: "排序鍵最大長度為50",
  invalidSortTypeFormat: "排序類型格式無效",
  invalidPackageId: "包 ID 無效",
  invalidAccountStatusFormat: "帳戶狀態格式無效",
  invalidSiteStatusFormat: "網站狀態格式無效",
  invalidPackageStatus: "無效的包裹狀態",
  invalidEmailFormat: "「電子郵件格式無效」，",
  invalidPhoneFormat: "電話格式無效",
  languageLengthNotInRange: "語言長度不在範圍 （2-5） 內，",
  languageDescriptionMaxLength50: "語言描述最大長度為50，",
  remarkMaxLength500: "備註最大長度為 500，",
  themeProviderTypeMaxLength50: "主題提供程式類型最大長度為50，",
  themeNameMaxLength50: "主題名稱最大長度為50，",
  themeColorMaxLength20: "主題顏色最大長度為20",
  noSpace: "不得包含空格",
  packageDescEnRequired: "姓名英文是必填的",
  packageDescEnMaxLength20: "名稱英文最大長度為20",
  allParamsIsNull: "所有參數均為空",
  contentCannotBeRemove: "「無法刪除內容」，",
  contentDetailsRequired: "需要內容詳細資訊",
  domainCannotBeUse: "域無法使用",
  domainGroupMaxLength20: "域組最大長度為20",
  domainGroupRequired: "需要域組",
  domainNameCannotUpdate: "域名無法更新",
  domainNameMaxLength400: "域名最大長度為400",
  domainsRequired: "域是必需的",
  domainStatusMaxLength20: "域狀態最大長度為20",
  domainTypeMaxLength10: "域類型最大長度為10",
  funcAddThemeContentGroupFailed: "添加主題內容組失敗",
  funcDeleteThemeContentGroupFailed: "刪除主題內容組失敗",
  funcOpsiteUpdateFailed: "Opsite 更新失敗",
  funcResetAccountPasswordFailed: "重置帳戶密碼失敗",
  funcSiteLanguageUpsertFailed: "網站語言更新插入失敗",
  funcSiteThemeContentUpsertFailed: "網站主題內容更新插入失敗",
  funcSiteThemeUpsertFailed: "網站主題更新插入失敗",
  funcSiteUpdateFailed: "網站更新失敗",
  funcUpdateAccountFailed: "更新帳戶失敗，",
  funcUpdateAccountStatusActiveFailed: "將帳戶狀態更新為活動失敗",
  funcUpdateAccountStatusCompanyBlockFailed: "將帳戶狀態更新為公司阻止失敗",
  funcUpdateAccountStatusSuspendFailed: "將帳戶狀態更新為暫停失敗",
  funcUpdateThemeContentGroupFailed: "更新主題內容組失敗，",
  invalidBoDomain: "無效的 BO 域",
  invalidOperatorIdFormat: "運算子 ID 格式無效",
  invalidOpsite: "無效的 opsite",
  invalidOpsiteOperator: "無效的作符",
  invalidOpsiteVersion: "無效的opsite版本",
  invalidParentContentInGroup: "組中的父內容無效",
  invalidSite: "無效網站",
  invalidSiteStatus: "網站狀態無效",
  invalidThemeContentGroup: "主題內容組無效，",
  languageCannotBeUse: "語言不能使用",
  languagesRequired: "語言是必需的",
  logo1Required: "需要徽標",
  notSupportMultiDefault: "不支援多預設",
  operatorIdMaxLength50: "操作員ID最大長度為50",
  opsiteNotMatch: "Opsite 不匹配",
  packageTypeMaxLength15: "包裝類型最大長度為15",
  parentContentIdCannotSameWithContentId: "父級內容 ID 不能與內容 ID 相同",
  phoneNumberRequired: "電話號碼是必填的",
  siteIdRequired: "需要網站 ID",
  siteNameMaxLength50: "網站名稱最大長度為 50",
  siteNameRequired: "網站名稱是必填項",
  technicalError: "技術錯誤",
  themeCannotBeRemove: "主題無法刪除，",
  themeCodeCannotBeUse: "主題代碼不能使用，",
  themeCodeMaxLength20: "主題代碼最大長度為20，",
  themeColorCannotBeRemove: "主題顏色無法刪除，",
  themeColorCannotBeUse: "主題色不能使用，",
  themeContentCannotBeUse: "主題內容無法使用，",
  themeContentGroupCannotBeUse: "「無法使用主題內容組」，",
  themeContentGroupDescriptionMaxLength50: "主題內容組描述最大長度為50，",
  themeContentGroupMaxLength20: "主題內容組最大長度為20，",
  themeContentGroupRequired: "主題內容組是必填的",
  themeNameCannotBeUse: "「無法使用主題名稱」，",
  userHaventVerifyThisBefore: "使用者之前沒有驗證過這一點",
  isDefaultTrueRequired: "語言必須有1個預設值",
  accountIdMaxLength50: "使用者ID最大長度為50",
  headBodyScriptEitherOne: "請輸入頭部腳本或正文腳本",
  alphaOrNum: "必須是字母或數位",
  phoneValid: "請輸入有效的電話號碼",
  permittedAmountRequired: "需要允許的金額",
  ignoreRiskRequired: "需要忽略風險",
  paymentDescRequired: "需要付款說明",
  gameTypeRequired: "遊戲類型是必需的",
  statusRequired: "狀態是必需的",
  payoutIdRequired: "需要支付ID",
  commNotExists: "傭金不存在",
  parentCommNotExists: "「不存在家長傭金」，",
  carryOverNotExists: "結轉不存在，",
  hotGameExists: "熱門遊戲已經存在「，",
  commSportsExceededParent: "體育傭金超過父母",
  commSlotsExceededParent: "插槽傭金超出父級",
  commLivecasinoExceededParent: "真人娛樂場的傭金超出了母公司，",
  commCockfightExceededParent: "鬥雞傭金超過父母",
  commOthersExceededParent: "他人傭金超過母公司",
  hotGameNotExists: "熱遊戲不存在",
  noSecurityDeposit: "沒有擔保金",
  exchangeRateNotExists: "匯率不存在",
  insufficientSecurityDeposit: "安全基金不足",
  duplicateDomain: "重複域，",
  contactEmailNotExists: "聯繫電子郵件不存在，",
  featuredGameNotExists: "功能遊戲不存在",
  newGameNotExists: "新遊戲不存在",
  popularGameNotExists: "熱門遊戲不存在，",
  featuredGameExists: "特色遊戲已經存在",
  newGameExists: "新遊戲已經存在",
  popularGameExists: "熱門遊戲已經存在「，",
  rebateNotExists: "不存在返利，",
  riskyMember: "風險成員",
  ipRestricted: "IP 受限",
  notSupportedBank: "不支持銀行。",
  requestTooFrequent: "請求太頻繁了。",
  paymentOptionNotExists: "付款選項不存在。",
  earningIdRequired: "需要收入 ID。",
  ptOnRequired: "PT on required.",
  ptRequired: "需要 PT。",
  userIdRequired: "需要使用者 ID。",
  businessIdRequired: "需要企業ID。",
  subAccountIdRequired: "需要子帳戶 ID。",
  sourceAccountIdRequired: "需要源帳戶 ID。",
  targetAccountIdRequired: "需要目標帳戶 ID。",
  ticketTaken: "票已拿走",
  ticketNotTaken: "不買票",
  invalidPt: "PT 無效",
  topupIdRequired: "需要充值 ID",
  promotionMemberLogNotExists: "促銷會員日誌不存在",
  paymentOptionInactive: "付款選項無效",
  invalidCartStatusFormat: "購物車狀態格式無效",
  requestIncompleted: "請求未完成",
  unknownError: "發生未知錯誤",
  cartIdRequired: "需要購物車 ID",
  stepNameRequired: "步驟名稱是必填項",
  invalidCart: "無效購物車",
  invalidStepName: "步驟名稱無效",
  cartHaventSetupComplete: "購物車尚未完成設置",
  funcCartCreateFailed: "「無法創建購物車」，",
  funcCartUpdateFailed: "無法更新購物車",
  funcSiteCreateFailed: "「無法創建網站」，",
  funcCartPurchasedUpdateFailed: "無法更新購買的購物車",
  invalidPasswordFormat: "密碼格式無效",
  currencyCodeRequired: "貨幣是必需的",
  funcCartLanguageUpsertFailed: "函數車語言更新插入失敗，",
  invalidUserIdFormat: "使用者 ID 格式無效",
  operatorPasswordRequired: "需要操作員密碼",
  funcCartOperatorInfoUpsertFailed: "函數車運算子資訊更新插入失敗，",
  invalidOperatorPasswordFormat: "操作員密碼格式無效",
  operatorIdCannotBeUse: "「無法使用運營商ID」，",
  siteNameLengthNotInRange: "網站名稱長度不在範圍內",
  userIdCannotBeUse: "「無法使用使用者ID」，",
  siteIdAlrdExist: "網站 ID 已存在",
  operatorIdAlrdExist: "運營商ID已存在",
  externalIdAlrdExist: "外部 ID 已存在",
  opsiteContentAlrdExist: "網站內容主題內容已存在",
  opsiteLanguageAlrdExist: "網站內容語言已存在",
  boAccountAlrdExist: "BO 帳戶已存在",
  boAccountProfileAlrdExist: "BO 帳戶配置檔已存在",
  boAccountLoginAlrdExist: "BO 帳戶登錄已存在",
  funcCartThemeCodeUpsertFailed: "無法更新插入購物車主題",
  funcCartThemeColorUpsertFailed: "無法更新插入購物車顏色",
  funcOpsiteCreateFailed: "「無法創建網站內容」，",
  alphabetValid: "必須至少有一個大小寫字母",
  numberValid: "必須至少有一個數位",
  symbolValid: "必須至少有一個符號",
  credentialNotSet: "未設置憑據",
  validBankAccFormat: "不合法的銀行帳戶編號。格式，",
  moreThan: "{fname} 必須小於或等於 {fname2}",
  lessThan: "{fname} 必須大於或等於 {fname2}。",
  bankAccountNotAvailable: "銀行帳戶不可用。",
  insufficientCredit: "信用不足",
  enableRequired: "啟用是必需的。",
  funcAddGameFailed: "添加遊戲失敗。",
  funcAddGameRewardByBatchFailed: "無法按批次添加遊戲獎勵。",
  funcAddGameRewardFailed: "無法添加遊戲獎勵。",
  funcAddGameTemplateFailed: "無法添加遊戲範本。",
  funcAddLayoutTemplateFailed: "無法添加佈局範本。",
  funcAddOperatorGameFailed: "無法添加操作員遊戲。",
  funcAddOperatorMemberWalletFailed: "無法添加運營商成員錢包。",
  funcDeleteGameFailed: "無法刪除遊戲。",
  funcDeleteGameRewardFailed: "無法刪除遊戲獎勵。",
  funcDeleteGameTemplateFailed: "無法刪除遊戲範本。",
  funcDeleteLayoutTemplateFailed: "無法刪除佈局範本。",
  funcDeleteOperatorGameFailed: "無法刪除操作員遊戲。",
  funcUpdateGameFailed: "無法更新遊戲。",
  funcUpdateGameRewardFailed: "無法更新遊戲獎勵。",
  funcUpdateGameTemplateFailed: "無法更新遊戲範本。",
  funcUpdateLayoutTemplateFailed: "無法更新佈局範本。",
  funcUpdateOperatorGameFailed: "無法更新操作員遊戲。",
  gameCannotBeRemove: "遊戲無法刪除。",
  gameNameCannotBeUse: "不能使用遊戲名稱。",
  gameNameMaxLength150: "遊戲名稱最多必須有 150 個字元。",
  gameRewardCannotBeUse: "無法使用遊戲獎勵。",
  gameRewardLimitExceeded: "超出遊戲獎勵限制。",
  gameTemplateExist: "遊戲範本已經存在。",
  gameTypeMaxLength20: "遊戲類型最多必須有20個字元。",
  invalidGame: "無效遊戲。",
  invalidGameReward: "遊戲獎勵無效。",
  invalidGameTemplate: "遊戲範本無效。",
  invalidMemberWallet: "會員錢包無效。",
  invalidOperatorGame: "無效的運營商遊戲。",
  invalidRewardProbability: "獎勵概率無效。",
  invalidTemplate: "範本無效。",
  maxGameRewardRequired: "需要最大的遊戲獎勵。",
  maxMiniGameRewardRequired: "需要最大的迷你遊戲獎勵。",
  memberWalletAlrdExist: "會員錢包已經存在。",
  operatorGameCannotBeUse: "無法使用幹員遊戲。",
  operatorGameIdRequired: "需要操作員遊戲 ID。",
  rewardCodeMaxLength20: "獎勵代碼必須最多 20 個字元。",
  rewardCodeRequired: "獎勵代碼是必填的。",
  rewardCurrencyMaxLength5: "獎勵貨幣最多必須為 5 個字元。",
  rewardCurrencyRequired: "獎勵貨幣是必需的。",
  rewardDescriptionMaxLength100: "獎勵描述最多必須有 100 個字元。",
  rewardNameMaxLength50: "獎勵名稱必須最多為 50 個字元。",
  rewardProbabilityRequired: "獎勵概率是必需的。",
  rewardRequired: "需要獎勵。",
  selectedTemplateMaxLength30: "所選範本最多必須有 30 個字元。",
  selectedTemplateRequired: "選定的範本是必需的。",
  success: "成功。",
  templateCannotBeRemove: "範本無法刪除。",
  templateCodeCannotBeUse: "範本代碼不能使用。",
  templateCodeMaxLength30: "範本代碼最多必須為 30 個字元。",
  templateCodeRequired: "範本代碼是必需的。",
  templateNameMaxLength50: "範本名稱最多必須為50個字元。",
  tokenRequestRequired: "需要令牌請求。",
  tokenRequired: "令牌是必需的。",
  mustMoreThan: "{fname} 必須大於 {fvalue}",
  mustMoreThanOrEqual: "{fname} 必須大於或等於 {fvalue}",
  tokenInvalid: "令牌輸入在 {key} 處無效",
  cashInvalid: "{key} 處的現金輸入無效",
  atLeastOneRequired: "至少需要一個",
  cash1To7Required: "需要現金 1 至 7",
  cash1To6Required: "需要現金 1 至 6",
  cash1To5Required: "需要現金 1 至 5",
  cash1To4Required: "需要現金 1 到 4",
  cash1To3Required: "需要現金 1 到 3",
  cash1To2Required: "需要現金 1 到 2",
  cash1Required: "需要現金 1",
  token1To7Required: "需要令牌 1 到 7",
  token1To6Required: "需要令牌 1 到 6",
  token1To5Required: "需要令牌 1 到 5",
  token1To4Required: "需要令牌 1 到 4",
  token1To3Required: "需要標記 1 到 3",
  token1To2Required: "需要令牌 1 到 2",
  token1Required: "需要令牌 1",
  cycleRequired: "週期是必需的",
  targetAmountRequired: "需要目標金額",
  gamifyIdRequired: "需要獎勵ID",
  gamifyMemberProcessed: "獎勵會員已處理",
  gamifyNotExists: "獎勵不存在",
  gamifyInactive: "獎勵處於非活動狀態",
  invalidCycle: "無效迴圈",
  memberIdMaxLength50: "會員編號不得超過50個字元",
  funcAddGameWalletFreeCreditFailed: "無法向遊戲錢包添加免費積分",
  funcUpdateOperatorMemberWalletBalanceFailed: "無法更新運營商成員錢包餘額",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "未能按凍結金額更新運營商會員錢包餘額",
  mustHaveBothAlphaNumOnly: "只使用字母和數位，每種至少一個。",
  setupGameRewardBeforeEnable: "請在啟用遊戲獎勵之前設置好遊戲獎勵。",
  rewardProbabilityMustNotAllZero: "獎勵概率不能全部為零。",
  totalRewardProbabilityCannotOver100: "總獎勵概率不能超過 100。",
  credential1To2Required: "需要證書 1 到 2。",
  credential1To4Required: "需要證書 1 到 4。",
  newRemarkRequired: "需要備註。",
  notSupportedWithdrawalPG: "不支援的提款支付閘道。",
  prizeInvalid: "在 {key} 的獎品輸入無效",
  exceedMaxCampaignCount: "已超過排行榜活動的最大數量。",
  leaderboardCampaignEnded: "排行榜活動已結束。",
  leaderboardCampaignStarted: "排行榜活動已開始。",
  leaderboardCampaignSettled: "排行榜活動已結算。",
  pleaseSelectUpToNoPhone: "請選擇最多 {fname} 個電話號碼。",
  phoneNotAvailable: "電話不可用。",
  batchExpired: "批次已過期。",
  remarkNotSame: "備註不一致",
  partnerIdRequired: "需要合作夥伴ID",
  partnerNotExists: "合作夥伴不存在",
  urgencyRequired: "需要緊急程度",
  groupSizeRequired: "需要群組大小",
  inactiveDaysRequired: "需要填寫未使用天數",
  idRequired: "需要ID",
  expiryRequired: "需要到期日期",
  batchIdRequired: "需要批次ID",
  requestDateRequired: "需要請求日期",
  requestByRequired: "需要請求人",
  cpiIdRequired: "需要CPI ID",
  assigneeRequired: "需要負責人",
  phoneNotAvailable: "電話不可用",
  liveChatNotExists: "即時聊天不存在",
  resultNotExists: "結果不存在",
  lastLaunchFundTransfer: "上次啟動資金轉帳",
  alreadyRegistered: "已註冊",
  invalidId: "無效的ID",
  batchExpired: "批次已過期",
  teleCalling: "電話呼叫",
  invalidUrgency: "無效的緊急程度",
  appTypeRequired: "需要應用程式類型",
  invalidAppType: "無效的應用程式類型",
  appLinkRequired: "需要應用程式連結",
  invalidDomain: "無效的網域",
  existEndDateGtEndDate: "現有結束日期晚於新結束日期",
  newRemark2Required: "需要新的備註2",
  remark2NotSame: "備註2不一致",
  remark2Required: "需要備註2",
  nameRequired: "需要名稱",
  aiAssistantNotExists: "AI助理不存在",
  aiAssistantInactive: "AI助理未啟用",
  phoneStartWithVND: "電話號碼必須以 84 開頭",
  otherActiveLiveChat: "有其他正在进行的LiveChat",
  whiteLabelRequired: "需要 White Label",
  invalidWhiteLabel: "無效的 White Label",
  baseRateDepositRequired: "需要基準存款利率",
  revisionRequired: "需要修訂",
  typeDescRequired: "需要類型描述",
  riskWeightRequired: "需要風險權重",
  linkageTypeRequired: "需要連結類型",
  valueRequired: "需要數值",
  baseRateWithdrawalRequired: "需要基準提款利率",
  sourceIdRequired: "需要來源 ID",
  targetIdRequired: "需要目標 ID",
  linkageTypeNotExists: "連結類型不存在",
  phoneStartWithMYR: "電話號碼必須以 84 開頭",
  minWithdrawalAmount100: "最低提款金額為 100",
  invalidReward: "無效獎勵",
  noRow: "沒有資料列",
  credentialRequired: "需要憑證",
  settlementIdRequired: "需要結算ID",
  settlementDateRequired: "需要結算日期",
  newCryptoAddressRequired: "需要新的加密地址",
  cryptoAddressRequired: "需要加密地址",
  settlementTypeRequired: "需要結算類型",
  chatProviderRequired: "需要聊天供應商",
  countRequired: "需要數量",
  voucherCodeRequired: "需要憑證代碼",
  eventTypeRequired: "需要事件類型",
  viewTypeRequired: "需要檢視類型",
  actionTypeRequired: "需要動作類型",
  thresholdRequired: "需要門檻值",
  missionIdRequired: "需要任務ID",
  ruleIdRequired: "需要規則ID",
  aggregatorRequired: "需要聚合器",
  rebateIdRequired: "需要返利ID",
  liveChatExists: "此即時聊天已存在",
  triggerNotExists: "觸發條件不存在",
  missionRuleNotExists: "任務規則不存在",
  invalidVoucherCode: "無效的憑證代碼",
  invalidRebateType: "無效的返利類型",
  invalidSettlementType: "無效的結算類型",
  missionNotExists: "任務不存在",
  settlementTypeNotExists: "結算類型不存在",
  parentTriggerInactive: "父觸發條件未啟用",
  parentMissionInactive: "父任務未啟用",
  missionRuleNotSet: "任務規則未設定",
  invalidCreditType: "無效的信用類型",
  cryptoDisabled: "加密已停用",
  depositExists: "存款已存在",
  parentSettlementTypeNotExists: "父結算類型不存在",
  accessControlNotExists: "存取控制不存在",
  cryptoAccountFull: "加密帳戶已滿",
  cryptoAccountExists: "加密帳戶已存在",
  cryptoAccountNotExists: "加密帳戶不存在",
  settlementNotAvailable: "結算不可用",
  settlementProcessed: "結算已處理",
  cryptoAccountInactive: "加密帳戶未啟用",
  leadIdRequired: "需要線索ID",
  failedToCreateFreeRound: "建立免費回合失敗。",
  failedToGetFreeRound: "取得免費回合失敗。",
  failedToGetFreeRoundGameList: "取得免費回合遊戲列表失敗。",
  tierFull: "等級已滿",
  tierNotExists: "等級不存在",
  ticketTypeRequired: "票券類型為必填",
  invalidTicketType: "票券類型無效",
  positionRequired: "位置為必填",
  invalidPosition: "位置無效",
  invalidBonusRate: "獎勵比例無效",
  minRequired: "最小值為必填",
  maxRequired: "最大值為必填",
  minGtMax: "最小值大於最大值。",
  sessionExists: "場次已存在",
  sessionOverlaps: "場次重疊",
  sessionIdRequired: "場次 ID 為必填",
  sessionNotExists: "場次不存在",
  nameExists: "名稱已存在",
  sessionElapsed: "場次已結束",
  validUrl: "請輸入有效的 URL",
  minBalanceNotMet: "未達最低餘額",
  validSlugFormat: "網址代稱格式無效",

  failedToCancelFreeRound: "取消免費回合失敗。",
  failedToGetFreeRoundLineBet: "取得免費回合線路投注失敗。",
};